import { render } from "./AppNotificationDialog.vue?vue&type=template&id=1eb6f35e"
import script from "./AppNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./AppNotificationDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script